export default __webpack_public_path__ + "cb9d8006963329e433854800c3e50b2a.jpg";